import React from "react";
import Seo from "../components/Seo";
import Breadcrumbs from "../components/Breadcrumbs";
import ApartmentCard from "../components/ApartmentCard";
import SectionHeader from "../components/SectionHeader";
import { apartments, accommodationConditions, pricingRules } from "../data/site";
import { usePhotoOverrides } from "../lib/photos";

export default function Ubytovani() {
  const c = accommodationConditions;
  const photos = usePhotoOverrides();
  return (
    <main id="main">
      <Seo path="/ubytovani" title="Ubytování u vinaře – 3 apartmány u Lednice | Ubytování u vinaře"
        description="Tři apartmány v Charvátské Nové Vsi pro páry, rodiny, cyklisty a turisty. Klidné ubytování kousek od Lednice a Valtic." />
      <Breadcrumbs items={[{ label: "Ubytování" }]} />
      <section className="max-w-[1400px] mx-auto px-5 md:px-10 py-14 md:py-20">
        <SectionHeader as="h1" eyebrow="Ubytování u vinaře" title={"Apartmány pro klidný pobyt na\u00A0jižní Moravě."}
          kicker="Nabízíme ubytování ve&nbsp;3&nbsp;apartmánech. Dostupnost konkrétního apartmánu potvrzujeme osobně." />
        <h2 className="sr-only">Naše apartmány</h2>
        <div className="mt-12 grid md:grid-cols-3 gap-5">
          {apartments.map((a) => {
            const ov = photos.first("apartment", a.slug);
            return <ApartmentCard key={a.slug} apt={a} imageOverride={ov?.src} waiting={!photos.loaded} />;
          })}
        </div>

        <div className="mt-20 grid md:grid-cols-2 gap-10">
          <div>
            <h2 className="font-serif text-3xl">Podmínky pobytu</h2>
            <ul className="mt-4 space-y-2 text-charcoal/80">
              <li>• Minimální délka pobytu: {c.minNights} noci</li>
              <li>• Check-in {c.checkIn}, check-out {c.checkOut}</li>
              <li>• {c.parking}</li>
              <li>• {c.pets}</li>
              <li>• {c.bicycleStorage}</li>
              <li>• {c.children}</li>
              <li>• Místní poplatek z&nbsp;pobytu: {c.localFee}</li>
            </ul>
          </div>
          <div>
            <h2 className="font-serif text-3xl">Ceny a&nbsp;rezervace</h2>
            <ul className="mt-4 space-y-2 text-charcoal/80">
              <li>• {pricingRules.perPersonSummer}&nbsp;Kč / osoba / noc mimo zimní období</li>
              <li>• Listopad–březen: {pricingRules.perPersonWinter}&nbsp;Kč / osoba / noc</li>
              <li>• Účtuje se skutečný počet ubytovaných osob.</li>
              <li>• Záloha: {c.deposit}</li>
              <li>• Platba: {c.payment}</li>
              <li>• Dostupnost potvrzujeme osobně – žádné okamžité rezervace online.</li>
            </ul>
          </div>
        </div>
      </section>
    </main>
  );
}
